import React from 'react';

import { Tabs } from '@mui/material';
import { ClipboardText, UserOctagon } from 'iconsax-reactjs';
import { useTranslation } from 'react-i18next';

import { TabStyled } from '../../styles';
import { IUserFormTab } from '../../types';

interface IProps {
  view: IUserFormTab;
  onChange: (view: IUserFormTab) => void;
}

const UserFormTabs = React.memo(({ view, onChange }: IProps) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={view}
      onChange={(event, newValue) => onChange(newValue as IUserFormTab)}
      sx={{
        minHeight: 'unset',
      }}
      slots={{
        indicator: () => null,
      }}
      slotProps={{
        list: {
          sx: {
            gap: 1,
          },
        },
      }}
    >
      <TabStyled
        icon={<UserOctagon />}
        iconPosition="start"
        key={`user_form_tab_${IUserFormTab.professional}`}
        label={t(`profile.tabs.${IUserFormTab.professional}`)}
        value={IUserFormTab.professional}
      />

      <TabStyled
        icon={<ClipboardText />}
        iconPosition="start"
        key={`user_form_tab_${IUserFormTab.cv}`}
        label={t(`profile.tabs.${IUserFormTab.cv}`)}
        value={IUserFormTab.cv}
      />
    </Tabs>
  );
});

export default UserFormTabs;
